import { SinglePage, MyCV, CoverLetter, AllBlogs, IndividualBlog, GalleryAdmin, Login, BlogAdmin, ProjectsAdmin, NotFound } from '../pages';

export const routes = [
    {
        path: '',
        element: <SinglePage/>,
    },
    {
        path: '/cv',
        element: <MyCV />,
    },
    {
        path: '/cover-letter',
        element: <CoverLetter />,
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/admin',
        element: <BlogAdmin />,
    },
    {
        path: '/admin/gallery',
        element: <GalleryAdmin />,
    },
    {
        path: '/admin/projects',
        element: <ProjectsAdmin />,
    },
    {
        path: '/insights',
        element: <AllBlogs />,
    },
    {
        path: '/insights/:id',
        element: <IndividualBlog />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
];
